import Cookies from 'js-cookie';
var TokenKey = 'Lepu-Basic-Token';
var Secret = 'Lepu-Secret';
var ExpTime = 30 * 24 * 60 * 60 * 1000;
export function getToken() {
  return Cookies.get(TokenKey);
}
export function setToken(token) {
  return Cookies.set(TokenKey, token);
}
export function removeToken() {
  return Cookies.remove(TokenKey);
} // 获取上传图片的secret

export function getSecret() {
  return Cookies.get(Secret);
} // 设置上传图片的secret

export function setSecret(secret) {
  return Cookies.set(Secret, secret, ExpTime);
} // 清除上传图片的secret

export function removeSecret() {
  return Cookies.remove(Secret);
}